module.exports = __webpack_public_path__ + "img/hematologue-h.01cef30e.jpg";